// extracted by mini-css-extract-plugin
export default {"tor":"PasekPostepu_tor__LiNHa","przyklejony":"PasekPostepu_przyklejony__I5VRR","wypelnienie":"PasekPostepu_wypelnienie__zgvia","koniec":"PasekPostepu_koniec__dvHF2"};